import path from 'path';
import React from 'react';

/* Add To Cart plugin */
import CommerceAddToCartWrapper, {
  createCommerceAddToCartWrapper,
} from './CommerceAddToCartWrapper';
import CommerceAddToCartForm from './CommerceAddToCartForm';
import CommerceAddToCartButton from './CommerceAddToCartButton';
import CommerceAddToCartQuantityInput from './CommerceAddToCartQuantityInput';
import CommerceAddToCartOutOfStock from './CommerceAddToCartOutOfStock';
import CommerceAddToCartError from './CommerceAddToCartError';
import {
  LegacyCommerceAddToCartOptionList,
  CommerceAddToCartOptionListWithSelectorTypes,
} from './CommerceAddToCartOptionList';
import CommerceAddToCartOption from './CommerceAddToCartOption';
import CommerceAddToCartOptionLabel from './CommerceAddToCartOptionLabel';
import CommerceAddToCartOptionSelect from './CommerceAddToCartOptionSelect';
import CommerceAddToCartOptionPillGroup from './CommerceAddToCartOptionPillGroup';
import CommerceAddToCartOptionPill from './CommerceAddToCartOptionPill';
import CommerceBuyNowButton from './CommerceBuyNowButton';

/* Cart plugin */
import CommerceCartWrapper, {
  createCommerceCartWrapper,
} from './CommerceCartWrapper';
import CommerceCartOpenLink from './CommerceCartOpenLink';
import CommerceCartOpenLinkCount from './CommerceCartOpenLinkCount';
import CommerceCartOpenLinkIcon from './CommerceCartOpenLinkIcon';
import CommerceCartContainerWrapper from './CommerceCartContainerWrapper';
import CommerceCartContainer from './CommerceCartContainer';
import CommerceCartHeader from './CommerceCartHeader';
import CommerceCartHeading from './CommerceCartHeading';
import CommerceCartFormWrapper from './CommerceCartFormWrapper';
import CommerceCartForm from './CommerceCartForm';
import CommerceCartEmptyState from './CommerceCartEmptyState';
import CommerceCartErrorState from './CommerceCartErrorState';
import CommerceCartList from './CommerceCartList';
import CommerceCartFooter from './CommerceCartFooter';
import CommerceCartLineItem from './CommerceCartLineItem';
import CommerceCartCheckoutButton from './CommerceCartCheckoutButton';
import CommerceCartItem from './CommerceCartItem';
import CommerceCartItemImage from './CommerceCartItemImage';
import CommerceCartItemInfo from './CommerceCartItemInfo';
import CommerceCartProductName from './CommerceCartProductName';
import CommerceCartProductPrice from './CommerceCartProductPrice';
import CommerceCartQuantity from './CommerceCartQuantity';
import CommerceCartCloseLink from './CommerceCartCloseLink';
import CommerceCartCloseLinkIcon from './CommerceCartCloseLinkIcon';
import CommerceCartRemoveLink from './CommerceCartRemoveLink';
import CommerceCartOrderValue from './CommerceCartOrderValue';
import CommerceCartCheckoutActions from './CommerceCartCheckoutActions';
import CommerceCartOptionList from './CommerceCartOptionList';
import CommerceCartOptionListItem from './CommerceCartOptionListItem';
import CommerceCartOptionListItemLabel from './CommerceCartOptionListItemLabel';
import CommerceCartOptionListItemValue from './CommerceCartOptionListItemValue';
import CommerceCartQuickCheckoutActions from './CommerceCartQuickCheckoutActions';
import CommerceCartQuickCheckoutButton from './CommerceCartQuickCheckoutButton';
import CommerceCartApplePayButton from './CommerceCartApplePayButton';
import CommerceCartApplePayIcon from './CommerceCartApplePayIcon';
import CommerceQuickCheckoutGoogleIcon from './CommerceQuickCheckoutGoogleIcon';
import CommerceQuickCheckoutMicrosoftIcon from './CommerceQuickCheckoutMicrosoftIcon';

/* Checkout */
import CommerceCheckoutBlockContent from './CommerceCheckoutBlockContent';
import CommerceCheckoutBlockHeader from './CommerceCheckoutBlockHeader';
import CommerceCheckoutColumn from './CommerceCheckoutColumn';
import CommerceCheckoutFormContainer, {
  createCommerceCheckoutFormContainer,
} from './CommerceCheckoutFormContainer';
import CommerceCheckoutLabel from './CommerceCheckoutLabel';
import CommerceLabel from './CommerceLabel';
import CommerceCheckoutRow from './CommerceCheckoutRow';
import CommerceCheckoutCardExpirationDate from './CommerceCheckoutCardExpirationDate';
import CommerceCheckoutCardNumber from './CommerceCheckoutCardNumber';
import CommerceCheckoutCardSecurityCode from './CommerceCheckoutCardSecurityCode';
import CommerceCheckoutCustomerInfoWrapper from './CommerceCheckoutCustomerInfoWrapper';
import CommerceCheckoutErrorState from './CommerceCheckoutErrorState';
import CommerceCheckoutPaymentInfoWrapper from './CommerceCheckoutPaymentInfoWrapper';
import CommerceCheckoutPlaceOrderButton from './CommerceCheckoutPlaceOrderButton';
import CommerceCheckoutEmailInput from './CommerceCheckoutEmailInput';
import CommerceCheckoutShippingAddressWrapper from './CommerceCheckoutShippingAddressWrapper';
import CommerceCheckoutShippingCountrySelector from './CommerceCheckoutShippingCountrySelector';
import CommerceCheckoutShippingFullName from './CommerceCheckoutShippingFullName';
import CommerceCheckoutShippingStreetAddress from './CommerceCheckoutShippingStreetAddress';
import CommerceCheckoutShippingStreetAddressOptional from './CommerceCheckoutShippingStreetAddressOptional';
import CommerceCheckoutShippingCity from './CommerceCheckoutShippingCity';
import CommerceCheckoutShippingZipPostalCode from './CommerceCheckoutShippingZipPostalCode';
import CommerceCheckoutShippingStateProvince from './CommerceCheckoutShippingStateProvince';
import CommerceOrderConfirmation from './CommerceOrderConfirmation';
import CommerceOrderConfirmationContainer, {
  createCommerceOrderConfirmationContainer,
} from './CommerceOrderConfirmationContainer';
import CommerceOrderConfirmationHeaderWrapper from './CommerceOrderConfirmationHeaderWrapper';
import CommerceCheckoutBillingAddressWrapper from './CommerceCheckoutBillingAddressWrapper';
import CommerceCheckoutBillingCountrySelector from './CommerceCheckoutBillingCountrySelector';
import CommerceCheckoutBillingFullName from './CommerceCheckoutBillingFullName';
import CommerceCheckoutBillingStreetAddressOptional from './CommerceCheckoutBillingStreetAddressOptional';
import CommerceCheckoutBillingStreetAddress from './CommerceCheckoutBillingStreetAddress';
import CommerceCheckoutBillingCity from './CommerceCheckoutBillingCity';
import CommerceCheckoutBillingZipPostalCode from './CommerceCheckoutBillingZipPostalCode';
import CommerceCheckoutBillingStateProvince from './CommerceCheckoutBillingStateProvince';
import CommerceCheckoutBillingAddressToggleWrapper from './CommerceCheckoutBillingAddressToggleWrapper';
import CommerceCheckoutBillingAddressToggleLabel from './CommerceCheckoutBillingAddressToggleLabel';
import CommerceCheckoutBillingAddressToggleCheckbox from './CommerceCheckoutBillingAddressToggleCheckbox';
/* Checkout Order Items Widget */
import CommerceCheckoutOrderItemsWrapper, {
  createCommerceCheckoutOrderItemsWrapper,
} from './CommerceCheckoutOrderItemsWrapper';
import CommerceCheckoutOrderItemsList from './CommerceCheckoutOrderItemsList';
import CommerceCheckoutOrderItem from './CommerceCheckoutOrderItem';
import CommerceBoldTextBlock from './CommerceBoldTextBlock';
import CommerceCheckoutOrderItemDescriptionWrapper from './CommerceCheckoutOrderItemDescriptionWrapper';
import CommerceCheckoutOrderItemQuantityWrapper from './CommerceCheckoutOrderItemQuantityWrapper';
import CommerceCheckoutOrderItemOptionList from './CommerceCheckoutOrderItemOptionList';
import CommerceCheckoutOrderItemOptionListItem from './CommerceCheckoutOrderItemOptionListItem';
import CommerceCheckoutOrderItemOptionListItemLabel from './CommerceCheckoutOrderItemOptionListItemLabel';
import CommerceCheckoutOrderItemOptionListItemValue from './CommerceCheckoutOrderItemOptionListItemValue';
import CommerceCheckoutOrderItemTrialTextWrapper from './CommerceCheckoutOrderItemTrialTextWrapper';
/* Checkout Shipping Methods Widget */
import CommerceCheckoutShippingMethodsWrapper from './CommerceCheckoutShippingMethodsWrapper';
import CommerceCheckoutShippingMethodsEmptyState from './CommerceCheckoutShippingMethodsEmptyState';
import CommerceCheckoutShippingMethodsList from './CommerceCheckoutShippingMethodsList';
import CommerceCheckoutShippingMethodItem from './CommerceCheckoutShippingMethodItem';
import CommerceCheckoutShippingMethodRadioButton from './CommerceCheckoutShippingMethodRadioButton';
import CommerceCheckoutShippingMethodDescriptionBlock from './CommerceCheckoutShippingMethodDescriptionBlock';
import CommerceCheckoutShippingMethodNameBlock from './CommerceCheckoutShippingMethodNameBlock';
import CommerceCheckoutShippingMethodBlockWrapper from './CommerceCheckoutShippingMethodBlockWrapper';
/* Checkout Shipping Methods Widget */
import CommerceCheckoutCustomerInfoSummaryWrapper, {
  createCommerceCheckoutCustomerInfoSummaryWrapper,
} from './CommerceCheckoutCustomerInfoSummaryWrapper';
import CommerceCheckoutShippingSummaryWrapper, {
  createCommerceCheckoutShippingSummaryWrapper,
} from './CommerceCheckoutShippingSummaryWrapper';
import CommerceCheckoutPaymentSummaryWrapper from './CommerceCheckoutPaymentSummaryWrapper';
import CommerceCheckoutOrderSummaryWrapper, {
  createCommerceCheckoutOrderSummaryWrapper,
} from './CommerceCheckoutOrderSummaryWrapper';
import CommerceCheckoutOrderSummaryExtraItemsList from './CommerceCheckoutOrderSummaryExtraItemsList';
import CommerceCheckoutOrderSummaryExtraItemsListItem from './CommerceCheckoutOrderSummaryExtraItemsListItem';
import CommerceCheckoutSummaryItem from './CommerceCheckoutSummaryItem';
import CommerceCheckoutSummaryLabel from './CommerceCheckoutSummaryLabel';
import CommerceCheckoutSummaryLineItem from './CommerceCheckoutSummaryLineItem';
import CommerceCheckoutSummaryBlockHeader from './CommerceCheckoutSummaryBlockHeader';
import CommerceCheckoutSummaryTotal from './CommerceCheckoutSummaryTotal';
import CommerceCheckoutSummaryFlexBoxDiv from './CommerceCheckoutSummaryFlexBoxDiv';
import CommerceCheckoutSummaryTextSpacingOnDiv from './CommerceCheckoutSummaryTextSpacingOnDiv';
import CommerceCheckoutOrderItemDescriptionPrice from './CommerceCheckoutOrderItemDescriptionPrice';
import CommerceCheckoutErrorMsg from './CommerceCheckoutErrorMsg';
import CommerceCartErrorMsg from './CommerceCartErrorMsg';
import CommerceAddToCartErrorMsg from './CommerceAddToCartErrorMsg';
import CommercePayPalCheckoutButton from './CommercePayPalCheckoutButton';

/*Checkout and order confirmation page layout*/
import CommerceLayoutMain from './CommerceLayoutMain';
import CommerceLayoutSidebar from './CommerceLayoutSidebar';
import CommerceLayoutContainer from './CommerceLayoutContainer';

import CommerceCheckoutAdditionalInfoSummaryWrapper from './CommerceCheckoutAdditionalInfoSummaryWrapper';
import CommerceCheckoutAdditionalInputsContainer from './CommerceCheckoutAdditionalInputsContainer';
import CommerceCheckoutAdditionalTextArea from './CommerceCheckoutAdditionalTextArea';
import CommerceCheckoutAdditionalTextInput from './CommerceCheckoutAdditionalTextInput';
import CommerceCheckoutAdditionalCheckboxWrapper from './CommerceCheckoutAdditionalCheckboxWrapper';
import CommerceCheckoutAdditionalCheckbox from './CommerceCheckoutAdditionalCheckbox';

/*PayPal Checkout */
import CommercePaypalCheckoutFormContainer, {
  createCommercePaypalCheckoutFormContainer,
} from './CommercePaypalCheckoutFormContainer';
import CommercePaypalCheckoutErrorState from './CommercePaypalCheckoutErrorState';
import CommercePaypalCheckoutErrorMessage from './CommercePaypalCheckoutErrorMessage';

// Downloads
import CommerceDownloadsWrapper from './CommerceDownloadsWrapper';
import CommerceDownloadsList from './CommerceDownloadsList';
import CommerceDownloadsItem from './CommerceDownloadsItem';

import {WebPaymentsSelect} from './dataTypes/WebPaymentsSelect';
import {
  MultiTextEditType,
  AddToCartButtonMultiTextEditType,
} from './dataTypes/MultiTextEditType';

import {
  isCheckoutPage,
  isOrderConfirmationPage,
  isPaypalCheckoutPage,
  buildQuickCheckoutActionsExpression,
  buildCheckoutItemTrialTextWrapper,
  buildCheckoutPaymentSummaryExpression,
} from './CommerceUtils';

import MultiTextEdit, {
  defaultMultiTextStateValue,
} from './settings/MultiTextEdit';
import MultiTextEditWithCategories from './settings/MultiTextEditWithCategories';
import LockedDynSource from './settings/LockedDynSource';
import DismissibleNote from './settings/DismissibleNote';

/*Discounts*/
import CommerceCheckoutDiscounts from './CommerceCheckoutDiscounts';
import CommerceCheckoutDiscountsButton from './CommerceCheckoutDiscountsButton';
import CommerceCheckoutDiscountsInput from './CommerceCheckoutDiscountsInput';
import CommerceCheckoutDiscountsLabel from './CommerceCheckoutDiscountsLabel';

import CartTypeDataType from './dataTypes/CartTypeDataType';

/* Icons */
// TODO replace icon
import CustomerInfoIcon from './icons/customer-info';
import ShippingInfoIcon from './icons/shipping-info';
import PaymentInfoIcon from './icons/payment-info';
import WebPaymentsElementSmallIcon from './icons/web-payments';
import PayPalCheckoutIcon from './icons/paypal-checkout';
import AddPanelDownloadsIcon from './icons/addpanel-downloads';
import {
  ElementCartIcon,
  ElementATCIcon as AddToCartElementIcon,
  ElementDiscountIcon as DiscountIcon,
  FieldPriceIcon as CurrencyIcon,
  AttachmentIcon as DownloadIcon,
  AddPanelAddToCart64Icon,
  AddPanelCart64Icon,
  AddPanelPaypal64Icon,
  AddPanelWebPayment64Icon,
  AddPanelDiscounts64Icon,
  AddPanelAdditionalInfo64Icon,
  AddPanelOrderItems64Icon,
  AddPanelOrderSummary64Icon,
} from '@packages/systems/spring';

import {
  DATA_ATTR_NODE_TYPE,
  NODE_TYPE_COMMERCE_DOWNLOADS_BUTTON,
  SECTION_NAMES,
} from '@packages/systems/commerce/constants';
import {
  Plugins,
  ElementPreset,
  Component,
  TypeImplementation,
  getMeta,
} from '@packages/systems/wfdl';
import {iconName, qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {useExpressionEditorImplementationContext} from '@packages/systems/ExpressionEditor-utils';
import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  EEnum,
  EList,
  ELiteral,
  ENumber,
} from '@packages/systems/wfdl-ast';
import {wrapAddPanelIcon} from '@packages/systems/ui/shared-ui/wrapAddPanelIcon';

import {
  ContextualExpressions,
  stripAnn,
  getAnn,
} from '@packages/utilities/contextual-expression';
import {PageRecordType} from '@packages/systems/core/records/PageRecord';

const AddPanelAddToCartIcon = wrapAddPanelIcon(AddPanelAddToCart64Icon);
const AddPanelCartIcon = wrapAddPanelIcon(AddPanelCart64Icon);
const AddPanelPaypalIcon = wrapAddPanelIcon(AddPanelPaypal64Icon);
const AddPanelWebPaymentIcon = wrapAddPanelIcon(AddPanelWebPayment64Icon);
const AddPanelDiscountsIcon = wrapAddPanelIcon(AddPanelDiscounts64Icon);
const AddPanelAdditionalInfoIcon = wrapAddPanelIcon(
  AddPanelAdditionalInfo64Icon
);
const AddPanelOrderItemsIcon = wrapAddPanelIcon(AddPanelOrderItems64Icon);
const AddPanelOrderSummaryIcon = wrapAddPanelIcon(AddPanelOrderSummary64Icon);

const basicPlugin = Plugins.name('Basic');

const showIfUserSetupCommerce = ({
  didUserSetUpCommerce,
}: {
  didUserSetUpCommerce: boolean;
}) => (didUserSetUpCommerce ? SECTION_NAMES.ECOMMERCE : null);

const showOnCheckoutOrPaypalCheckoutPage = ({
  currentPage: page,
  didUserSetUpCommerce,
}: {
  currentPage: PageRecordType;
  didUserSetUpCommerce: boolean;
}) => {
  if (!didUserSetUpCommerce) return null;

  if (isCheckoutPage(page)) {
    return SECTION_NAMES.CHECKOUT_PAGE;
  }

  if (isPaypalCheckoutPage(page)) {
    return SECTION_NAMES.PAYPAL_CHECKOUT_PAGE;
  }

  return null;
};

const showOnCheckoutPage = ({
  currentPage: page,
  didUserSetUpCommerce,
}: {
  currentPage: PageRecordType;
  didUserSetUpCommerce: boolean;
}) =>
  didUserSetUpCommerce && isCheckoutPage(page)
    ? SECTION_NAMES.CHECKOUT_PAGE
    : null;

const showOnOrderConfirmationPage = ({
  currentPage: page,
  didUserSetUpCommerce,
}: {
  currentPage: PageRecordType;
  didUserSetUpCommerce: boolean;
}) =>
  didUserSetUpCommerce && isOrderConfirmationPage(page)
    ? SECTION_NAMES.ORDER_CONFIRMATION_PAGE
    : null;

const showOnPaypalCheckoutPage = ({
  currentPage: page,
  didUserSetUpCommerce,
}: {
  currentPage: PageRecordType;
  didUserSetUpCommerce: boolean;
}) =>
  didUserSetUpCommerce && isPaypalCheckoutPage(page)
    ? SECTION_NAMES.PAYPAL_CHECKOUT_PAGE
    : null;

const showOnOrderConfirmationOrPaypalCheckoutPage = ({
  currentPage: page,
  didUserSetUpCommerce,
}: {
  currentPage: PageRecordType;
  didUserSetUpCommerce: boolean;
}) =>
  didUserSetUpCommerce && isOrderConfirmationPage(page)
    ? SECTION_NAMES.ORDER_CONFIRMATION_PAGE
    : isPaypalCheckoutPage(page)
      ? SECTION_NAMES.PAYPAL_CHECKOUT_PAGE
      : null;

const showOnCheckoutOrOrderConfirmationOrPaypalCheckoutPage = ({
  currentPage: page,
  didUserSetUpCommerce,
}: {
  currentPage: PageRecordType;
  didUserSetUpCommerce: boolean;
}) =>
  didUserSetUpCommerce && isCheckoutPage(page)
    ? SECTION_NAMES.CHECKOUT_PAGE
    : isOrderConfirmationPage(page)
      ? SECTION_NAMES.ORDER_CONFIRMATION_PAGE
      : isPaypalCheckoutPage(page)
        ? SECTION_NAMES.PAYPAL_CHECKOUT_PAGE
        : null;

export const plugin = Plugins.PrivilegedPlugin({
  stateAtom: 'CommerceAddToCartWrapper',
  atoms: {
    /* Add To Cart plugin */
    CommerceAddToCartForm,
    CommerceAddToCartButton,
    CommerceAddToCartWrapper,
    CommerceAddToCartQuantityInput,
    CommerceAddToCartError,
    CommerceAddToCartOutOfStock,
    CommerceAddToCartOptionList: LegacyCommerceAddToCartOptionList,
    CommerceAddToCartOptionListWithSelectorTypes,
    CommerceAddToCartOption,
    CommerceAddToCartOptionLabel,
    CommerceAddToCartOptionSelect,
    CommerceAddToCartOptionPillGroup,
    CommerceAddToCartOptionPill,
    CommerceBuyNowButton,
    /* Cart plugin */
    CommerceCartWrapper,
    CommerceCartOpenLink,
    CommerceCartOpenLinkCount,
    CommerceCartOpenLinkIcon,
    CommerceCartContainerWrapper,
    CommerceCartContainer,
    CommerceCartHeader,
    CommerceCartHeading,
    CommerceCartFormWrapper,
    CommerceCartForm,
    CommerceCartEmptyState,
    CommerceCartErrorState,
    CommerceCartList,
    CommerceCartFooter,
    CommerceCartLineItem,
    CommerceCartCheckoutButton,
    CommerceCartItem,
    CommerceCartItemImage,
    CommerceCartItemInfo,
    CommerceCartProductName,
    CommerceCartProductPrice,
    CommerceCartQuantity,
    CommerceCartCloseLink,
    CommerceCartCloseLinkIcon,
    CommerceCartRemoveLink,
    CommerceCartOrderValue,
    CommerceCartCheckoutActions,
    CommerceCartOptionList,
    CommerceCartOptionListItem,
    CommerceCartOptionListItemLabel,
    CommerceCartOptionListItemValue,
    CommerceCartQuickCheckoutActions,
    CommerceCartQuickCheckoutButton,
    CommerceCartApplePayButton,
    CommerceCartApplePayIcon,
    CommerceQuickCheckoutGoogleIcon,
    CommerceQuickCheckoutMicrosoftIcon,
    CommercePayPalCheckoutButton,
    /* Checkout */
    CommerceCheckoutBlockContent,
    CommerceCheckoutBlockHeader,
    CommerceCheckoutColumn,
    CommerceCheckoutFormContainer,
    CommerceCheckoutRow,
    CommerceCheckoutLabel,
    CommerceLabel,
    CommerceCheckoutCardExpirationDate,
    CommerceCheckoutCardNumber,
    CommerceCheckoutCardSecurityCode,
    CommerceCheckoutCustomerInfoWrapper,
    CommerceCheckoutErrorState,
    CommerceCheckoutPaymentInfoWrapper,
    CommerceCheckoutPlaceOrderButton,
    CommerceCheckoutEmailInput,
    CommerceCheckoutShippingAddressWrapper,
    CommerceCheckoutShippingCountrySelector,
    CommerceCheckoutShippingFullName,
    CommerceCheckoutShippingStreetAddress,
    CommerceCheckoutShippingStreetAddressOptional,
    CommerceCheckoutShippingCity,
    CommerceCheckoutShippingZipPostalCode,
    CommerceCheckoutShippingStateProvince,
    CommerceOrderConfirmation,
    CommerceOrderConfirmationContainer,
    CommerceOrderConfirmationHeaderWrapper,
    CommerceCheckoutBillingAddressWrapper,
    CommerceCheckoutBillingCountrySelector,
    CommerceCheckoutBillingFullName,
    CommerceCheckoutBillingStreetAddress,
    CommerceCheckoutBillingStreetAddressOptional,
    CommerceCheckoutBillingCity,
    CommerceCheckoutBillingZipPostalCode,
    CommerceCheckoutBillingStateProvince,
    CommerceCheckoutBillingAddressToggleWrapper,
    CommerceCheckoutBillingAddressToggleCheckbox,
    CommerceCheckoutBillingAddressToggleLabel,
    /* Checkout Order Items Widget */
    CommerceCheckoutOrderItemsWrapper,
    CommerceCheckoutOrderItemsList,
    CommerceCheckoutOrderItem,
    CommerceBoldTextBlock,
    CommerceCheckoutOrderItemDescriptionWrapper,
    CommerceCheckoutOrderItemQuantityWrapper,
    CommerceCheckoutOrderItemOptionList,
    CommerceCheckoutOrderItemOptionListItem,
    CommerceCheckoutOrderItemOptionListItemLabel,
    CommerceCheckoutOrderItemOptionListItemValue,
    CommerceCheckoutOrderItemTrialTextWrapper,
    /* Checkout Shipping Methods Widget */
    CommerceCheckoutShippingMethodsWrapper,
    CommerceCheckoutShippingMethodsEmptyState,
    CommerceCheckoutShippingMethodsList,
    CommerceCheckoutShippingMethodItem,
    CommerceCheckoutShippingMethodRadioButton,
    CommerceCheckoutShippingMethodDescriptionBlock,
    CommerceCheckoutShippingMethodNameBlock,
    CommerceCheckoutShippingMethodBlockWrapper,
    /* Checkout Summary */
    CommerceCheckoutCustomerInfoSummaryWrapper,
    CommerceCheckoutShippingSummaryWrapper,
    CommerceCheckoutPaymentSummaryWrapper,
    CommerceCheckoutOrderSummaryWrapper,
    CommerceCheckoutSummaryItem,
    CommerceCheckoutSummaryLabel,
    CommerceCheckoutSummaryBlockHeader,
    CommerceCheckoutSummaryLineItem,
    CommerceCheckoutSummaryTotal,

    CommerceCheckoutSummaryTextSpacingOnDiv,
    CommerceCheckoutSummaryFlexBoxDiv,
    CommerceCheckoutOrderItemDescriptionPrice,
    CommerceCheckoutOrderSummaryExtraItemsList,
    CommerceCheckoutOrderSummaryExtraItemsListItem,
    /* Checkout Error State */
    CommerceCheckoutErrorMsg,
    /* Cart Error State */
    CommerceCartErrorMsg,
    /* Add to cart Error State */
    CommerceAddToCartErrorMsg,
    /*Checkout and order confirmation page layout*/
    CommerceLayoutMain,
    CommerceLayoutSidebar,
    CommerceLayoutContainer,
    /*PayPal Checkout*/
    CommercePaypalCheckoutFormContainer,
    CommercePaypalCheckoutErrorState,
    CommercePaypalCheckoutErrorMessage,

    CommerceCheckoutAdditionalInputsContainer,
    CommerceCheckoutAdditionalInfoSummaryWrapper,
    CommerceCheckoutAdditionalTextArea,
    CommerceCheckoutAdditionalTextInput,
    CommerceCheckoutAdditionalCheckbox,
    CommerceCheckoutAdditionalCheckboxWrapper,
    /* Discounts */
    CommerceCheckoutDiscounts,
    CommerceCheckoutDiscountsButton,
    CommerceCheckoutDiscountsInput,
    CommerceCheckoutDiscountsLabel,
    // Downloads
    CommerceDownloadsWrapper,
    CommerceDownloadsList,
    CommerceDownloadsItem,
  },
  icons: {
    Downloads: DownloadIcon,
    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Omit<any, "ref"> & RefAttributes<any>>' is not assignable to type 'ComponentType<IconProps>'.
    OrderItems: AddPanelOrderItemsIcon,
    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Omit<any, "ref"> & RefAttributes<any>>' is not assignable to type 'ComponentType<IconProps>'.
    OrderSummary: AddPanelOrderSummaryIcon,
    CustomerInfo: CustomerInfoIcon,
    ShippingInfo: ShippingInfoIcon,
    PaymentInfo: PaymentInfoIcon,
    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Omit<any, "ref"> & RefAttributes<any>>' is not assignable to type 'ComponentType<IconProps>'.
    AddToCart: AddPanelAddToCartIcon,
    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Omit<any, "ref"> & RefAttributes<any>>' is not assignable to type 'ComponentType<IconProps>'.
    Cart: AddPanelCartIcon,
    ElementCart: ElementCartIcon,
    AddToCartElement: AddToCartElementIcon,
    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Omit<any, "ref"> & RefAttributes<any>>' is not assignable to type 'ComponentType<IconProps>'.
    WebPaymentsElement: AddPanelWebPaymentIcon,
    WebPaymentsSmallElement: WebPaymentsElementSmallIcon,
    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Omit<any, "ref"> & RefAttributes<any>>' is not assignable to type 'ComponentType<IconProps>'.
    PayPal: AddPanelPaypalIcon,
    PayPalCheckout: PayPalCheckoutIcon,
    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Omit<any, "ref"> & RefAttributes<any>>' is not assignable to type 'ComponentType<IconProps>'.
    AdditionalInfo: AddPanelAdditionalInfoIcon,
    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Omit<any, "ref"> & RefAttributes<any>>' is not assignable to type 'ComponentType<IconProps>'.
    AddPanelDiscounts: AddPanelDiscountsIcon,
    AddPanelDownloads: AddPanelDownloadsIcon,
    Discounts12: DiscountIcon,
    Currency: CurrencyIcon,
  },
  dataTypes: {
    WebPaymentsSelect,
    CartType: CartTypeDataType,
    MultiTextEditAlias: MultiTextEditType,
    AddToCartButtonMultiTextEdit: AddToCartButtonMultiTextEditType,
    MultiTextEdit: TypeImplementation.Custom({
      render: ({expr, dispatch}) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const {env} = useExpressionEditorImplementationContext();
        const literal = ContextualExpressions.getLiteral(stripAnn(expr))?.value;
        if (literal == null) {
          return null;
        }

        const type = getAnn(expr)?.type;
        const maybeMeta = type ? getMeta(type) : {};
        const meta = maybeMeta || {};
        const textStates = meta.textStates || {};
        function filterTextStates() {
          return Object.keys(textStates).reduce<Record<string, any>>(
            (acc, key) => {
              const textState = textStates[key];
              if (
                !textState.beta ||
                env.isEnabled({type: 'betaFlag', key: textState.beta})
              ) {
                acc[key] = textState;
              }
              return acc;
            },
            {}
          );
        }
        const filteredTextStates = filterTextStates();
        return (
          <div>
            {meta.categories ? (
              <MultiTextEditWithCategories
                // @ts-expect-error, assume the literal contains the correct shape. Needs validation?
                state={literal}
                dispatch={dispatch}
                textStates={textStates}
                legacyStatePath={meta.legacyStatePath}
                categories={meta.categories}
                env={env}
              />
            ) : (
              <MultiTextEdit
                // @ts-expect-error, assume the literal contains the correct shape. Needs validation?
                state={literal}
                dispatch={dispatch}
                textStates={filteredTextStates}
                label={meta.label}
                legacyStatePath={meta.legacyStatePath}
                categories={meta.categories}
              />
            )}
          </div>
        );
      },
      system: {
        labelVariant: 'hidden',
        defaultValue: defaultMultiTextStateValue,
      },
    }),
    LockedDynSource: TypeImplementation.Custom({
      render: ({expr}) => {
        const ann = getAnn(expr);

        if (!ann.type) {
          return null;
        }

        const meta = getMeta(ann.type);
        const source = meta ? meta.source : '';
        return <LockedDynSource source={source} />;
      },
      system: {labelVariant: 'hidden'},
    }),
    DismissibleNote: TypeImplementation.Custom({
      render: ({expr, dispatch}) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const {env} = useExpressionEditorImplementationContext();
        const dismissed = ContextualExpressions.getLiteral(
          stripAnn(expr)
        )?.value;
        const ann = getAnn(expr);

        if (!ann.type) {
          return null;
        }

        const meta = getMeta(ann.type) || {};
        return !meta.beta ||
          env.isEnabled({type: 'betaFlag', key: meta.beta}) ? (
          <DismissibleNote
            dismissed={typeof dismissed === 'boolean' ? dismissed : false}
            dispatch={dispatch}
            content={meta.content}
            universityLink={meta.universityLink}
          />
        ) : null;
      },
      system: {labelVariant: 'hidden', defaultValue: false},
    }),
  },
  elementPresets: {
    CommercePaypalCheckoutFormContainer: ElementPreset.create({
      icon: {
        small: qualify(Plugins.name('Commerce'), iconName('PayPalCheckout')),
        medium: qualify(Plugins.name('Commerce'), iconName('PayPalCheckout')),
      },
      label: 'PayPal Checkout Form',
      factory: createCommercePaypalCheckoutFormContainer,
      category: showOnPaypalCheckoutPage,
      helpData: {
        description: [
          'Contains the entire PayPal checkout page form template elements. You can add it if you want to restore the default PayPal checkout page template.',
        ],
        link: {
          text: 'Check out the in-depth guide on connecting to PayPal',
          href: 'https://help.webflow.com/hc/en-us/articles/33961361368979-Connect-a-payment-provider',
        },
      },
    }),
    CommerceCheckoutFormContainer: ElementPreset.create({
      icon: {
        medium: qualify(basicPlugin, iconName('AddPanelDiv')),
        small: qualify(basicPlugin, iconName('Div')),
      },
      label: 'Checkout Form',
      factory: createCommerceCheckoutFormContainer,
      category: showOnCheckoutPage,
      helpData: {
        description: [
          'Contains the entire checkout page form template elements. You can add it if you want to restore the default checkout page template.',
        ],
        link: {
          text: 'Check out the in-depth guide to Checkout',
          href: 'https://help.webflow.com/hc/en-us/articles/33961364474643-Customize-the-shopping-cart-checkout-experience',
        },
      },
    }),
    CommerceOrderConfirmationContainer: ElementPreset.create({
      icon: {
        medium: qualify(basicPlugin, iconName('AddPanelDiv')),
        small: qualify(basicPlugin, iconName('Div')),
      },
      label: 'Order Confirmation',
      factory: createCommerceOrderConfirmationContainer,
      category: showOnOrderConfirmationPage,
      helpData: {
        description: [
          'Contains the entire order confirmation template elements. You can add it if you want to restore the default order confirmation page template.',
        ],
        link: {
          text: 'Check out the in-depth guide to Checkout',
          href: 'https://help.webflow.com/hc/en-us/articles/33961364474643-Customize-the-shopping-cart-checkout-experience',
        },
      },
    }),
    CommerceCheckoutOrderItemsWrapper: ElementPreset.create({
      icon: {
        small: qualify(Plugins.name('Commerce'), iconName('OrderItems')),
        medium: qualify(Plugins.name('Commerce'), iconName('OrderItems')),
      },
      label: 'Order Items',
      category: showOnCheckoutOrOrderConfirmationOrPaypalCheckoutPage,
      factory: createCommerceCheckoutOrderItemsWrapper,
      helpData: {
        description: [
          'Shows all the products and variants in the cart. The shopper can confirm that these are the products they want to purchase before they complete the checkout process.',
        ],
        link: {
          text: 'Check out the in-depth guide to Checkout',
          href: 'https://help.webflow.com/hc/en-us/articles/33961364474643-Customize-the-shopping-cart-checkout-experience',
        },
      },
    }),
    CommerceCheckoutOrderItemTrialTextWrapper: ElementPreset.create({
      icon: {
        small: qualify(Plugins.name('Basic'), iconName('Text')),
        medium: qualify(Plugins.name('Basic'), iconName('AddPanelText')),
      },
      beta: {enabledBasedOnFlags: {betaFlagName: 'trialSubscription'}},
      label: 'Trial Text',
      category: showOnCheckoutOrOrderConfirmationOrPaypalCheckoutPage,
      factory: buildCheckoutItemTrialTextWrapper,
      helpData: {
        description: ['Trial period in days for a subscription order item.'],
      },
    }),
    CommerceCheckoutCustomerInfoSummaryWrapper: ElementPreset.create({
      icon: {
        small: qualify(Plugins.name('Commerce'), iconName('CustomerInfo')),
        medium: qualify(Plugins.name('Commerce'), iconName('CustomerInfo')),
      },
      label: 'Customer Info',
      category: showOnOrderConfirmationOrPaypalCheckoutPage,
      factory: createCommerceCheckoutCustomerInfoSummaryWrapper,
      helpData: {
        description: [
          'Shows the email and shipping address that the customer provided in the checkout form.',
        ],
        link: {
          text: 'Check out the in-depth guide to Checkout',
          href: 'https://help.webflow.com/hc/en-us/articles/33961364474643-Customize-the-shopping-cart-checkout-experience',
        },
      },
    }),
    CommerceCheckoutShippingSummaryWrapper: ElementPreset.create({
      icon: {
        small: qualify(Plugins.name('Commerce'), iconName('ShippingInfo')),
        medium: qualify(Plugins.name('Commerce'), iconName('ShippingInfo')),
      },
      label: 'Shipping Method',
      category: showOnOrderConfirmationPage,
      factory: createCommerceCheckoutShippingSummaryWrapper,
      helpData: {
        description: ['Displays the shipping method chosen during checkout.'],
        link: {
          text: 'Check out the in-depth guide to Checkout',
          href: 'https://help.webflow.com/hc/en-us/articles/33961364474643-Customize-the-shopping-cart-checkout-experience',
        },
      },
    }),
    CommerceCheckoutPaymentSummaryWrapper: ElementPreset.create({
      icon: {
        small: qualify(Plugins.name('Commerce'), iconName('PaymentInfo')),
        medium: qualify(Plugins.name('Commerce'), iconName('PaymentInfo')),
      },
      label: 'Payment Info',
      category: showOnOrderConfirmationOrPaypalCheckoutPage,
      factory: buildCheckoutPaymentSummaryExpression(),
      helpData: {
        description: [
          'Shows the payment info and billing address that the customer provided during checkout.',
        ],
        link: {
          text: 'Check out the in-depth guide to Checkout',
          href: 'https://help.webflow.com/hc/en-us/articles/33961364474643-Customize-the-shopping-cart-checkout-experience',
        },
      },
    }),
    CommerceCheckoutOrderSummaryWrapper: ElementPreset.create({
      icon: {
        small: qualify(Plugins.name('Commerce'), iconName('OrderSummary')),
        medium: qualify(Plugins.name('Commerce'), iconName('OrderSummary')),
      },
      label: 'Order Summary',
      category: showOnCheckoutOrOrderConfirmationOrPaypalCheckoutPage,
      factory: createCommerceCheckoutOrderSummaryWrapper,
      helpData: {
        description: [
          "Shows the subtotal of the cart, any taxes and shipping rates, applied discounts, and the total of the order. This helps the shopper see a breakdown of the price they're paying.",
        ],
        tip: '',
        link: {
          text: 'Check out the in-depth guide to Checkout',
          href: 'https://help.webflow.com/hc/en-us/articles/33961364474643-Customize-the-shopping-cart-checkout-experience',
        },
      },
    }),
    CommerceCartWrapper: ElementPreset.create({
      icon: {
        small: qualify(Plugins.name('Commerce'), iconName('ElementCart')),
        medium: qualify(Plugins.name('Commerce'), iconName('Cart')),
      },
      label: 'Cart',
      factory: createCommerceCartWrapper,
      category: showIfUserSetupCommerce,
      helpData: {
        description: [
          'The cart component lets you add a shopping cart to your project. You can customize the look and feel of the cart button, which not only allows online shoppers to open the cart, but can also give them a quick overview of the number of items in their cart as well as the subtotal.',
        ],
        link: {
          text: 'Check out the in-depth guide on the Cart element',
          href: 'https://help.webflow.com/hc/en-us/articles/33961385828499-Cart-overview',
        },
      },
    }),
    CommerceAddToCartWrapper: ElementPreset.create({
      icon: {
        small: qualify(Plugins.name('Commerce'), iconName('AddToCartElement')),
        medium: qualify(Plugins.name('Commerce'), iconName('AddToCart')),
      },
      label: 'Add to Cart',
      factory: createCommerceAddToCartWrapper,
      category: showIfUserSetupCommerce,
      helpData: {
        description: [
          'One special element that you can add onto a product page or within a Collection list connected to the products category is the Add to cart element. This button allows users to add a product to their shopping cart.',
        ],
        link: {
          text: 'Check out the in-depth guide on Add to Cart buttons',
          href: 'https://help.webflow.com/hc/en-us/articles/33961359741715-Add-to-cart',
        },
      },
    }),
    CommerceCartQuickCheckoutActions: ElementPreset.create({
      icon: {
        small: qualify(
          Plugins.name('Commerce'),
          iconName('WebPaymentsElement')
        ),
        medium: qualify(
          Plugins.name('Commerce'),
          iconName('WebPaymentsElement')
        ),
      },
      label: 'Web Payments',
      factory: buildQuickCheckoutActionsExpression(),
      helpData: {
        description: [
          'Web Payments, such as Apple Pay and Google Pay, allow your customers to skip the default checkout process and quickly check out of your store by using their digital wallets.',
        ],
        tip: 'If you’ve enabled Web Payments for your site, your store’s cart and checkout page will automatically display the relevant Web Payment button on supported browsers.',
        link: {
          text: 'Check out the in-depth guide on Web Payments',
          href: 'https://help.webflow.com/hc/en-us/articles/33961404325651-Enable-Web-Payments',
        },
      },
      category: showIfUserSetupCommerce,
    }),
    CommercePayPalCheckoutButton: ElementPreset.create({
      icon: {
        small: qualify(Plugins.name('Commerce'), iconName('PayPal')),
        medium: qualify(Plugins.name('Commerce'), iconName('PayPal')),
      },
      label: 'PayPal',
      factory: EElement({
        id: 'Commerce Pay Pal Checkout Button',
        type: qualify(
          Plugins.name('Commerce'),
          Component.name('CommercePayPalCheckoutButton')
        ),
        data: ERecord({
          buttonStyle: ERecord({
            layout: EEnum('vertical'),
            color: EEnum('gold'),
            shape: EEnum('rect'),
            label: EEnum('paypal'),
            tagline: EBoolean(false),
            note: ELiteral({
              name: qualify(
                Plugins.name('Commerce'),
                typeName('DismissibleNote')
              ),
              value: false,
            }),
          }),
        }),
      }),
      category: showIfUserSetupCommerce,
      helpData: {
        description: [
          'Allow your customers to check out of your store using PayPal.',
        ],
        link: {
          text: 'Check out the in-depth guide on connecting to PayPal',
          href: 'https://help.webflow.com/hc/en-us/articles/33961361368979-Connect-a-payment-provider',
        },
      },
    }),
    CommerceCheckoutDiscounts: ElementPreset.create({
      icon: {
        small: qualify(Plugins.name('Commerce'), iconName('Discounts12')),
        medium: qualify(
          Plugins.name('Commerce'),
          iconName('AddPanelDiscounts')
        ),
      },
      label: 'Discounts',
      factory: () => {
        const discountsID = 'wf-ecom-discounts';

        return EElement({
          id: 'Commerce Checkout Discounts',
          type: qualify(
            Plugins.name('Commerce'),
            Component.name('CommerceCheckoutDiscounts')
          ),
          data: ERecord({
            children: EList([
              EElement({
                id: 'Commerce Checkout Discounts Label',
                type: qualify(
                  Plugins.name('Commerce'),
                  Component.name('CommerceCheckoutDiscountsLabel')
                ),
                data: ERecord({
                  attr: ERecord({
                    for: EText(discountsID),
                  }),
                  children: EList([
                    EElement({
                      id: 'Commerce Checkout Form Container String 35',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('String')
                      ),
                      data: EText('Discount Code'),
                    }),
                  ]),
                }),
              }),
              EElement({
                id: 'Commerce Checkout Discounts Input',
                type: qualify(
                  Plugins.name('Commerce'),
                  Component.name('CommerceCheckoutDiscountsInput')
                ),
                data: ERecord({
                  form: ERecord({
                    name: EText('field'),
                    type: EText('input'),
                    passwordPage: EBoolean(false),
                  }),
                  attr: ERecord({
                    id: EText(discountsID),
                    name: EText(''),
                    maxlength: ENumber(256),
                    type: EEnum('text'),
                    'data-name': EText('field'),
                    placeholder: EText(''),
                    disabled: EBoolean(false),
                    required: EBoolean(false),
                    autofocus: EBoolean(false),
                  }),
                }),
              }),
              EElement({
                id: 'Commerce Checkout Discounts Button',
                type: qualify(
                  Plugins.name('Commerce'),
                  Component.name('CommerceCheckoutDiscountsButton')
                ),
                data: ERecord({
                  buttonText: EText('Apply'),
                }),
              }),
            ]),
          }),
        });
      },
      category: showOnCheckoutOrPaypalCheckoutPage,
      helpData: {
        description: ['Allow your users to enter and apply a discount code.'],
        link: {
          text: 'Check out the in-depth guide to Discounts',
          href: 'https://help.webflow.com/hc/en-us/articles/33961399150611-Adding-discount-codes-in-Webflow-Ecommerce',
        },
      },
    }),
    CommerceCheckoutAdditionalInputsContainer: ElementPreset.create({
      icon: {
        small: qualify(Plugins.name('Commerce'), iconName('AdditionalInfo')),
        medium: qualify(Plugins.name('Commerce'), iconName('AdditionalInfo')),
      },
      label: 'Additional Info',
      factory: () => {
        const giftLabelID = 'wf-ecom-gift';
        const telephoneID = 'wf-ecom-telephone';
        const textAreaID = 'wf-ecom-notes';

        return EElement({
          id: 'Commerce Checkout Additional Inputs Container',
          type: qualify(
            Plugins.name('Commerce'),
            Component.name('CommerceCheckoutAdditionalInputsContainer')
          ),
          data: ERecord({
            includeTextInput: EBoolean(true),
            includeTextArea: EBoolean(true),
            includeCheckbox: EBoolean(true),
            children: EList([
              EElement({
                id: 'Commerce Checkout Summary Block Header 3',
                type: qualify(
                  Plugins.name('Commerce'),
                  Component.name('CommerceCheckoutSummaryBlockHeader')
                ),
                data: ERecord({
                  children: EList([
                    EElement({
                      id: 'Commerce Checkout Form Container Heading 8',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Heading')
                      ),
                      data: ERecord({
                        tag: EEnum('h2'),
                        children: EList([
                          EElement({
                            id: 'Commerce Checkout Form Container String 36',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('String')
                            ),
                            data: EText('Additional Information'),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
              EElement({
                id: 'Commerce Checkout Block Content 7',
                type: qualify(
                  Plugins.name('Commerce'),
                  Component.name('CommerceCheckoutBlockContent')
                ),
                data: ERecord({
                  children: EList([
                    EElement({
                      id: 'Commerce Checkout Label 17',
                      type: qualify(
                        Plugins.name('Commerce'),
                        Component.name('CommerceCheckoutLabel')
                      ),
                      data: ERecord({
                        attr: ERecord({
                          for: EText(telephoneID),
                        }),
                        children: EList([
                          EElement({
                            id: 'Commerce Checkout Form Container String 37',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('String')
                            ),
                            data: EText('Telephone'),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: 'Commerce Checkout Additional Text Input',
                      type: qualify(
                        Plugins.name('Commerce'),
                        Component.name('CommerceCheckoutAdditionalTextInput')
                      ),
                      data: ERecord({
                        name: EText('Telephone'),
                        placeholder: EText('Enter telephone number...'),
                        type: EEnum('tel'),
                        required: EBoolean(false),
                        attr: ERecord({
                          id: EText(telephoneID),
                        }),
                      }),
                    }),
                    EElement({
                      id: 'Commerce Checkout Label 18',
                      type: qualify(
                        Plugins.name('Commerce'),
                        Component.name('CommerceCheckoutLabel')
                      ),
                      data: ERecord({
                        attr: ERecord({
                          for: EText(textAreaID),
                        }),
                        children: EList([
                          EElement({
                            id: 'Commerce Checkout Form Container String 38',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('String')
                            ),
                            data: EText('Notes'),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: 'Commerce Checkout Additional Text Area',
                      type: qualify(
                        Plugins.name('Commerce'),
                        Component.name('CommerceCheckoutAdditionalTextArea')
                      ),
                      data: ERecord({
                        name: EText('Notes'),
                        placeholder: EText('Enter notes...'),
                        required: EBoolean(false),
                        attr: ERecord({
                          id: EText(textAreaID),
                        }),
                      }),
                    }),
                    EElement({
                      id: 'Commerce Checkout Additional Checkbox Wrapper',
                      type: qualify(
                        Plugins.name('Commerce'),
                        Component.name(
                          'CommerceCheckoutAdditionalCheckboxWrapper'
                        )
                      ),
                      data: ERecord({
                        children: EList([
                          EElement({
                            id: 'Commerce Checkout Additional Checkbox',
                            type: qualify(
                              Plugins.name('Commerce'),
                              Component.name(
                                'CommerceCheckoutAdditionalCheckbox'
                              )
                            ),
                            data: ERecord({
                              attr: ERecord({
                                'aria-labelledby': EText(giftLabelID),
                              }),
                              name: EText('Gift'),
                              startChecked: EBoolean(false),
                              required: EBoolean(false),
                            }),
                          }),
                          EElement({
                            id: 'Form Inline Label',
                            type: qualify(
                              Plugins.name('Form'),
                              Component.name('FormInlineLabel')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                id: EText(giftLabelID),
                              }),
                              form: ERecord({
                                type: EText('checkbox-label'),
                              }),
                              children: EList([
                                EElement({
                                  id: 'Commerce Checkout Form Container String 39',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Send as gift'),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        });
      },
      category: showOnCheckoutOrPaypalCheckoutPage,
      helpData: {
        description: [
          'Can be used to collect customer data like phone number, gift messages, and personalized instructions.',
        ],
        tip: "Make sure to update both Order and Checkout Confirmation, as these contain independent labels and fields that don't automatically sync.",
        link: {
          text: 'Check out the in-depth guide to Checkout',
          href: 'https://help.webflow.com/hc/en-us/articles/33961364474643-Customize-the-shopping-cart-checkout-experience',
        },
      },
    }),
    CommerceCheckoutAdditionalInfoSummaryWrapper: ElementPreset.create({
      icon: {
        small: qualify(Plugins.name('Commerce'), iconName('AdditionalInfo')),
        medium: qualify(Plugins.name('Commerce'), iconName('AdditionalInfo')),
      },
      label: 'Additional Info',
      factory: EElement({
        id: 'Commerce Checkout Additional Info Summary Wrapper',
        type: qualify(
          Plugins.name('Commerce'),
          Component.name('CommerceCheckoutAdditionalInfoSummaryWrapper')
        ),
        data: ERecord({
          children: EList([
            EElement({
              id: 'Commerce Checkout Summary Block Header 7',
              type: qualify(
                Plugins.name('Commerce'),
                Component.name('CommerceCheckoutSummaryBlockHeader')
              ),
              data: ERecord({
                children: EList([
                  EElement({
                    id: 'Commerce Order Confirmation Container Heading 7',
                    type: qualify(
                      Plugins.name('Basic'),
                      Component.name('Heading')
                    ),
                    data: ERecord({
                      tag: EEnum('h2'),
                      children: EList([
                        EElement({
                          id: 'Commerce Order Confirmation Container String 18',
                          type: qualify(
                            Plugins.name('Basic'),
                            Component.name('String')
                          ),
                          data: EText('Additional Information'),
                        }),
                      ]),
                    }),
                  }),
                ]),
              }),
            }),
            EElement({
              id: 'Commerce Checkout Block Content 7',
              type: qualify(
                Plugins.name('Commerce'),
                Component.name('CommerceCheckoutBlockContent')
              ),
              data: ERecord({
                children: EList([
                  EElement({
                    id: 'Commerce Checkout Summary Label 5',
                    type: qualify(
                      Plugins.name('Commerce'),
                      Component.name('CommerceCheckoutSummaryLabel')
                    ),
                    data: ERecord({
                      children: EList([
                        EElement({
                          id: 'Commerce Order Confirmation Container String 19',
                          type: qualify(
                            Plugins.name('Basic'),
                            Component.name('String')
                          ),
                          data: EText('Telephone'),
                        }),
                      ]),
                    }),
                  }),
                  EElement({
                    id: 'Commerce Order Confirmation Container Block 29',
                    type: qualify(
                      Plugins.name('Basic'),
                      Component.name('Block')
                    ),
                    data: ERecord({
                      tag: EEnum('div'),
                      text: EBoolean(true),
                      dyn: ERecord({
                        bind: ERecord({
                          innerHTML: EList([
                            ERecord({
                              slug: EText('additionalTextInput'),
                              type: EText('PlainText'),
                            }),
                          ]),
                        }),
                      }),
                      children: EList([]),
                    }),
                  }),
                  EElement({
                    id: 'Commerce Label',
                    type: qualify(
                      Plugins.name('Commerce'),
                      Component.name('CommerceLabel')
                    ),
                    data: ERecord({
                      children: EList([
                        EElement({
                          id: 'Commerce Order Confirmation Container String 20',
                          type: qualify(
                            Plugins.name('Basic'),
                            Component.name('String')
                          ),
                          data: EText('Notes'),
                        }),
                      ]),
                    }),
                  }),
                  EElement({
                    id: 'Commerce Order Confirmation Container Block 30',
                    type: qualify(
                      Plugins.name('Basic'),
                      Component.name('Block')
                    ),
                    data: ERecord({
                      tag: EEnum('div'),
                      text: EBoolean(true),
                      dyn: ERecord({
                        bind: ERecord({
                          innerHTML: EList([
                            ERecord({
                              slug: EText('additionalTextArea'),
                              type: EText('PlainText'),
                            }),
                          ]),
                        }),
                      }),
                      children: EList([]),
                    }),
                  }),
                  EElement({
                    id: 'Commerce Label 2',
                    type: qualify(
                      Plugins.name('Commerce'),
                      Component.name('CommerceLabel')
                    ),
                    data: ERecord({
                      children: EList([
                        EElement({
                          id: 'Commerce Order Confirmation Container String 21',
                          type: qualify(
                            Plugins.name('Basic'),
                            Component.name('String')
                          ),
                          data: EText('Send as gift'),
                        }),
                      ]),
                    }),
                  }),
                  EElement({
                    id: 'Commerce Order Confirmation Container Block 31',
                    type: qualify(
                      Plugins.name('Basic'),
                      Component.name('Block')
                    ),
                    data: ERecord({
                      tag: EEnum('div'),
                      text: EBoolean(true),
                      dyn: ERecord({
                        condition: ERecord({
                          class: ERecord({
                            false: ERecord({
                              'w-condition-invisible': ERecord({
                                fields: ERecord({
                                  additionalCheckbox: ERecord({
                                    eq: EText('true'),
                                  }),
                                }),
                              }),
                            }),
                          }),
                        }),
                      }),
                      children: EList([
                        EElement({
                          id: 'Commerce Order Confirmation Container String 22',
                          type: qualify(
                            Plugins.name('Basic'),
                            Component.name('String')
                          ),
                          data: EText('Yes'),
                        }),
                      ]),
                    }),
                  }),
                  EElement({
                    id: 'Commerce Order Confirmation Container Block 32',
                    type: qualify(
                      Plugins.name('Basic'),
                      Component.name('Block')
                    ),
                    data: ERecord({
                      tag: EEnum('div'),
                      text: EBoolean(true),
                      dyn: ERecord({
                        condition: ERecord({
                          class: ERecord({
                            false: ERecord({
                              'w-condition-invisible': ERecord({
                                fields: ERecord({
                                  additionalCheckbox: ERecord({
                                    ne: EText('true'),
                                  }),
                                }),
                              }),
                            }),
                          }),
                        }),
                      }),
                      children: EList([
                        EElement({
                          id: 'Commerce Order Confirmation Container String 23',
                          type: qualify(
                            Plugins.name('Basic'),
                            Component.name('String')
                          ),
                          data: EText('No'),
                        }),
                      ]),
                    }),
                  }),
                ]),
              }),
            }),
          ]),
        }),
      }),
      category: showOnOrderConfirmationPage,
      helpData: {
        description: [
          'Displays information entered in any of the additional info fields collected on checkout.',
        ],
        tip: "Make sure to update both Order and Checkout Confirmation, as these contain independent labels and fields that don't automatically sync.",
        link: {
          text: 'Check out the in-depth guide to Checkout',
          href: 'https://help.webflow.com/hc/en-us/articles/33961364474643-Customize-the-shopping-cart-checkout-experience',
        },
      },
    }),
    CommerceDownloadsWrapper: ElementPreset.create({
      icon: {
        medium: qualify(
          Plugins.name('Commerce'),
          iconName('AddPanelDownloads')
        ),
        small: qualify(Plugins.name('Commerce'), iconName('AddPanelDownloads')),
      },
      label: 'Downloads',
      factory: EElement({
        id: 'Commerce Downloads Wrapper',
        type: qualify(
          Plugins.name('Commerce'),
          Component.name('CommerceDownloadsWrapper')
        ),
        data: ERecord({
          dyn: ERecord({
            condition: ERecord({
              class: ERecord({
                false: ERecord({
                  'w-condition-invisible': ERecord({
                    fields: ERecord({
                      hasDownloads: ERecord({
                        eq: EText('true'),
                      }),
                    }),
                  }),
                }),
              }),
            }),
          }),
          children: EList([
            EElement({
              id: 'Commerce Checkout Summary Block Header 6',
              type: qualify(
                Plugins.name('Commerce'),
                Component.name('CommerceCheckoutSummaryBlockHeader')
              ),
              data: ERecord({
                children: EList([
                  EElement({
                    id: 'Commerce Order Confirmation Container Heading 6',
                    type: qualify(
                      Plugins.name('Basic'),
                      Component.name('Heading')
                    ),
                    data: ERecord({
                      tag: EEnum('h2'),
                      children: EList([
                        EElement({
                          id: 'Commerce Order Confirmation Container String 15',
                          type: qualify(
                            Plugins.name('Basic'),
                            Component.name('String')
                          ),
                          data: EText('Downloads'),
                        }),
                      ]),
                    }),
                  }),
                ]),
              }),
            }),
            EElement({
              id: 'Commerce Checkout Block Content 6',
              type: qualify(
                Plugins.name('Commerce'),
                Component.name('CommerceCheckoutBlockContent')
              ),
              data: ERecord({
                children: EList([
                  EElement({
                    id: 'Commerce Downloads List',
                    type: qualify(
                      Plugins.name('Commerce'),
                      Component.name('CommerceDownloadsList')
                    ),
                    data: ERecord({
                      source: ELiteral({
                        name: qualify(
                          Plugins.name('Commerce'),
                          typeName('LockedDynSource')
                        ),
                        value: '',
                      }),
                      children: EList([
                        EElement({
                          id: 'Commerce Downloads Item',
                          type: qualify(
                            Plugins.name('Commerce'),
                            Component.name('CommerceDownloadsItem')
                          ),
                          data: ERecord({
                            children: EList([
                              EElement({
                                id: 'Commerce Order Confirmation Container Block 24',
                                type: qualify(
                                  Plugins.name('Basic'),
                                  Component.name('Block')
                                ),
                                data: ERecord({
                                  tag: EEnum('div'),
                                  text: EBoolean(true),
                                  dyn: ERecord({
                                    bind: ERecord({
                                      innerHTML: EList([
                                        ERecord({
                                          slug: EText('name'),
                                          type: EText('PlainText'),
                                        }),
                                      ]),
                                    }),
                                  }),
                                  children: EList([]),
                                }),
                              }),
                              EElement({
                                id: 'Commerce Order Confirmation Container Link',
                                type: qualify(
                                  Plugins.name('Basic'),
                                  Component.name('Link')
                                ),
                                data: ERecord({
                                  attr: ERecord({
                                    [DATA_ATTR_NODE_TYPE]: EText(
                                      NODE_TYPE_COMMERCE_DOWNLOADS_BUTTON
                                    ),
                                  }),
                                  block: EText('inline'),
                                  button: EBoolean(true),
                                  eventIds: EList([]),
                                  link: ELiteral({
                                    name: qualify(
                                      Plugins.name('Basic'),
                                      typeName('Link')
                                    ),
                                    value: {mode: 'external', target: '_blank'},
                                  }),
                                  dyn: ERecord({
                                    bind: ERecord({
                                      href: EList([
                                        ERecord({
                                          slug: EText('url'),
                                          type: EText('Link'),
                                        }),
                                      ]),
                                    }),
                                  }),
                                  children: EList([
                                    EElement({
                                      id: 'Commerce Order Confirmation Container String 16',
                                      type: qualify(
                                        Plugins.name('Basic'),
                                        Component.name('String')
                                      ),
                                      data: EText('Download file'),
                                    }),
                                  ]),
                                }),
                              }),
                            ]),
                          }),
                        }),
                      ]),
                    }),
                  }),
                ]),
              }),
            }),
          ]),
        }),
      }),
      category: showOnOrderConfirmationPage,
      helpData: {
        description: ['Displays downloads available after checkout.'],
        tip: 'If you don’t have at least one product with a download, this element will be hidden on the canvas, even though it exists on the page and in the Navigator. And the Downloads element will only be visible on the live site if an order has a downloadable product.',
        link: {
          text: 'Check out the in-depth guide to Digital Downloads',
          href: 'https://help.webflow.com/hc/en-us/articles/33961269277203-Digital-downloads',
        },
      },
    }),
  },
  siteModules: [
    {
      filePaths: [path.resolve(__dirname, 'webflow-commerce.js')],
      bundleIf: {
        type: 'node',
        test: ({data = {}}) => data.commerce !== undefined,
      },
    },
  ],
});
